import { RequestHandler } from 'express';
import WorkflowsMigrationService from '~/services/WorkflowsMigrationService';
import mapAppErrorToObject from '~/transformations/mapAppErrorToObject';
import { saveRecorded } from '../mockingMiddleware';

export const getWorkflows: RequestHandler = async (req, res) => {
  try {
    const service = new WorkflowsMigrationService(
      res.locals.payload,
      res.locals.preview
    );

    await service.GetWorkflows();
    const response = service.MapGetWorkflowsResponse();

    res.send(response);
    saveRecorded(req, res, {
      operation: 'getWorkflows',
      response,
    });
  } catch (error: any) {
    res.status(500).send({ error: mapAppErrorToObject(error) });
  }
};
